import { render, staticRenderFns } from "./admin2PassDialog.vue?vue&type=template&id=61cdf7c8"
import script from "./admin2PassDialog.vue?vue&type=script&lang=js"
export * from "./admin2PassDialog.vue?vue&type=script&lang=js"
import style0 from "./admin2PassDialog.vue?vue&type=style&index=0&id=61cdf7c8&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports